import { render, staticRenderFns } from "./StatCard.vue?vue&type=template&id=85461004&scoped=true&"
import script from "./StatCard.vue?vue&type=script&lang=ts&"
export * from "./StatCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85461004",
  null
  
)

export default component.exports